require('../../modules/es.math.trunc');
var path = require('../../internals/path');

module.exports = path.Math.trunc;
